import React from 'react'
import styles from './Hero.module.scss'
import { Container, FlexColumn } from 'components/common/Containers'
import { Breadcrumbs, BreadcrumbsProps } from 'components/common/Breadcrumbs'
import { H1 } from 'components/common/Texts/H1/H1'
import classNames from 'classnames'

interface Props {
  breadcrumbsPath: BreadcrumbsProps['path']
  title: string
  description: string
  withImage?: boolean
}

const Hero: React.FC<Props> = ({
  children,
  breadcrumbsPath,
  title,
  description,
  withImage = false,
}) => {
  return withImage ? (
    <section
      className={classNames(
        styles.container,
        withImage && styles.imageContainer
      )}
    >
      <Container className={styles.imageWrap}>
        <FlexColumn className={styles.innerWrap}>
          <Breadcrumbs path={breadcrumbsPath} />
          <H1>{title}</H1>
          <p>{description}</p>
        </FlexColumn>
        {children}
      </Container>
    </section>
  ) : (
    <section className={styles.container}>
      <Container>
        <FlexColumn>
          <Breadcrumbs path={breadcrumbsPath} />
          <H1>{title}</H1>
          <p>{description}</p>
          {children}
        </FlexColumn>
      </Container>
    </section>
  )
}

export default Hero
